<template>
<div>
    <router-view></router-view>
</div>
</template>

<script>
export default {
  data: function () {
    return { 
      context: 'app context',
    };
  },
  mounted() {
  },
};
</script>


<style lang="scss">
@import '../node_modules/@braid/vue-formulate/themes/snow/snow.scss';
@import './static/css/main.scss';
.animated {
  animation-duration: .376s;
}
</style>



// WEBPACK FOOTER //
// App.vue?410726f8